import JSZip from 'jszip';

const DOWNLOAD_LABEL = 'Downloading study';

const sanitizeFolderPart = (value) => String(value || '')
  .replace(/[\\/:*?"<>|]+|\p{Cc}+/gu, '_')
  .replace(/\s+/g, ' ')
  .trim()
  .slice(0, 120);

export function buildStudyFolderName(study) {
  const parts = [];
  const desc = sanitizeFolderPart(study.description);
  if (desc) parts.push(desc);
  const date = sanitizeFolderPart((study.studyDate || '').slice(0, 10));
  if (date) parts.push(date);

  const name = parts.join(' - ');
  return name || sanitizeFolderPart(study.studyInstanceUID) || 'study';
}

export function collectStudyFileHashes(study) {
  return Array.from(new Set(
    (study.series || [])
      .flatMap((s) => s.fileHashes || [])
      .filter(Boolean)
  ));
}

function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export async function downloadStudyArchive({ study, downloadFile, onProgress }) {
  const folderName = buildStudyFolderName(study);
  const uniqueHashes = collectStudyFileHashes(study);
  if (!uniqueHashes.length) return false;

  const report = (percent, detail) => {
    if (onProgress) onProgress({ label: DOWNLOAD_LABEL, percent, detail });
  };

  const totalSteps = uniqueHashes.length + 1;
  report(0, `Downloading 0/${uniqueHashes.length} file(s)`);

  const zip = new JSZip();
  const studyFolder = zip.folder(folderName);

  let filesDone = 0;
  for (const hash of uniqueHashes) {
    const blob = await downloadFile(hash);
    studyFolder.file(`${hash}.dcm`, blob);
    filesDone += 1;
    report((filesDone / totalSteps) * 100, `Downloaded ${filesDone}/${uniqueHashes.length} file(s)`);
  }

  const filesShare = uniqueHashes.length / totalSteps;
  const zipBlob = await zip.generateAsync({ type: 'blob' }, (metadata) => {
    const zipFraction = (metadata.percent || 0) / 100;
    report(
      (filesShare + zipFraction * (1 - filesShare)) * 100,
      `Building archive (${Math.round(metadata.percent || 0)}%)`
    );
  });
  report(100, 'Archive ready');

  triggerBlobDownload(zipBlob, `${folderName}.zip`);
  return true;
}
